module.exports = __webpack_public_path__ + "media/images/themes/mandy/2-416b4c4251c7db55e4c2ac9f6ea66c1c.jpg";